<ng-container *ngIf="!assetTypeForm">
    <acabim-loading-view></acabim-loading-view>
</ng-container>

<ng-container *ngIf="assetTypeForm">
    <form [formGroup]="assetTypeForm">

        <ng-container *ngIf="!loading">
            <acabim-form-card-section>
                <p-toast key="assetTypeNameMissing" position="top-left"></p-toast>
                <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"
                                 acceptButtonStyleClass="cas-button-action"></p-confirmDialog>

                <div class="cas-form-text-input">
                    <h6>Name</h6>
                    <div class="p-inputgroup p-float-label">
                        <input type="text" formControlName="name" id="asset-type-name" placeholder="Enter an asset type name" />
                    </div>
                </div>
                <div class="cas-form-text-input">
                    <h6>Description</h6>
                    <div class="p-inputgroup p-float-label">
                        <input type="text" formControlName="description" id="asset-type-description" placeholder="Enter an asset type description" />
                    </div>
                </div>
                <div class="cas-action-buttons">
                    <button (click)="onCancel()">Cancel</button>
                    <button (click)="onAssetTypeDeleteSubmit()">Delete</button>
                    <button class="cas-button-action cas-button-right" (click)="onAssetTypeUpdateSubmit()">Update</button>
                </div>
            </acabim-form-card-section>
        </ng-container>

    </form>
</ng-container>
